import React, { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import BugsnagPerformance from '@bugsnag/browser-performance';
import { AppProvider } from "@/context/AppContext";
import { WalletProvider } from "@/context/WalletContext";
import { SocketProvider } from "@/context/SocketContext";
import { unregisterServiceWorker } from "@/lib/pwaInstall";
import App from "./App";
import { PWAInstallPrompt } from "@/components/PWAInstallPrompt";
import "./index.css";

Bugsnag.start({
  apiKey: '224348752155c86822652ece7eda81e0',
  plugins: [new BugsnagPluginReact()]
});
BugsnagPerformance.start({ apiKey: '224348752155c86822652ece7eda81e0' });

const ErrorBoundary = Bugsnag.getPlugin('react')!.createErrorBoundary(React);

// Remove old service worker to fix Vite HMR
unregisterServiceWorker();

createRoot(document.getElementById("root")!).render(
  <ErrorBoundary>
    <StrictMode>
      <WalletProvider>
        <SocketProvider>
          <AppProvider>
            <App />
            <PWAInstallPrompt />
          </AppProvider>
        </SocketProvider>
      </WalletProvider>
    </StrictMode>
  </ErrorBoundary>
);
